import { TherapyJobStatus } from '~/app/enums/TherapyJobStatus';
import { TherapyJobV2 } from '~/app/models/TherapyJobV2';
import { THIRTY_MINUTES } from '~/app/store/notification.store';
import { timePassedInMs } from '../TimePassed';

export const pendingConfirmationInfo = (tj: Partial<TherapyJobV2>) => {
  if (tj.status !== TherapyJobStatus.COMPLETED || !!tj.abortionTriggered) {
    return false;
  }

  if (!tj.endTime) {
    console.warn('Cannot set pending confirmation, the endTime is null');
    return false;
  }

  const withinTimeFrame = timePassedInMs(tj.endTime) <= THIRTY_MINUTES; // 30 minutes

  return withinTimeFrame;
};
